import api from '@/api/role'

export default {
  namespaced: true,
  state: {
    roles: [],
    totalRolesCount: 0,
    role: {}
  },
  mutations: {
    updateState(state, { stateProp, stateValue }) {
      state[stateProp] = stateValue
    }
  },
  actions: {
    /**
     * 获取角色列表信息
     *
     *  @returns {Promise} Promise apiResponse
     *  这里只是为了示例，实际情况一般不需要 return
     */
    async getRoles({ commit }, { query }) {
      let response = await api.getRoles(query)
      // 调用 API 返回数据
      // return api.getRoles(query).then(response => {
      //   // 更新记录 与 总数
      //   commit('updateState', { stateProp: 'roles', stateValue: response.data.entities })
      //   commit('updateState', { stateProp: 'totalRolesCount', stateValue: response.data.total })
      // })

      commit('updateState', {
        stateProp: 'roles',
        stateValue: response.data.entities
      })
      commit('updateState', {
        stateProp: 'totalRolesCount',
        stateValue: response.data.total
      })

      return response
    },

    /**
     * 获取指定用户信息
     *
     */
    getRole({ commit }, { id }) {
      api.getRole(id).then(response => {
        commit('updateState', {
          stateProp: 'role',
          stateValue: response.data.entity
        })
      })
    }
  }
}
